<template>
  <div class="d-flex">
    <div class="live event-minute">
      {{ event.minute }}'
      <span v-if="event.extraMinute > 0"
            class="event-extra-minute">
        +{{ event.extraMinute }}
      </span>
    </div>
    <div class="d-flex">
      <div v-if="playerPicture" class="d-flex">
        <div class="my-1 me-1">
          <player-avatar v-if="goal || change" :player="event.ownGoal ? event.negPlayer : event.posPlayer" size="32"/>
          <span v-if="change"> {{event.ownGoal ? event.negPlayer.surName : event.posPlayer.surName}} kommt für </span>
          <player-avatar v-if="card || change" :player="event.negPlayer" size="32"/>
          <span v-if="change" class="ms-1">{{event.negPlayer.surName}}</span>
        </div>
      </div>
      <div class="d-block">
        <div v-if="goal"
             class="live my-auto">
          <div>{{ event.goalsTeam1 }}:{{ event.goalsTeam2 }}</div>
          <div>Tor für
            <team-emblem :emblem-id="posTeam.emblemId" size="18"/>
            {{ posTeam.name }}
          </div>
          {{ event.ownGoal ? event.negPlayer.name + ' (ET)' : event.posPlayer.name }}
        </div>
        <div>
          <cld-image
              :public-id="cardImageId"
              v-if="card"
              height="13"/>
          <sakali-user
              v-if="coachAction"
              :show-avatar="true"
              :show-user="false"
              :user="posTeam.coach"/>
          <span v-if="showDescription">{{ description }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import matchEventDescription from "./match-event-description"
import PlayerAvatar from "@/components/PlayerAvatar";

const cardEvents = [27, 28, 29]

export default {
  components: {PlayerAvatar},
  props: {
    events: Array,
    matchReport: Object
  },
  computed: {
    description() {
      let res = ''
      this.events.forEach(e => res += (matchEventDescription(this.matchReport, e) + '. '))
      return res
    },
    event() {
      return this.events[this.events.length - 1]
    },
    goal() {
      return this.event.goal // s.reduce((isGoal, e) => isGoal |= e.goal, false)
    },
    card() {
      return cardEvents.includes(this.event.type)
    },
    posTeam() {
      return this.event.positiveForHome ? this.matchReport.team1 : this.matchReport.team2;
    },
    playerPicture() {
      return this.goal || this.card || this.change
    },
    cardImageId() {
      switch (this.event.type) {
        case 27:
          return 'sandkastenliga/card_yellow'
        case 28:
          return 'sandkastenliga/card_red'
        default:
          return 'sandkastenliga/card_yellow_red'
      }
    },
    coachAction() {
      return [22, 23, 24, 36, 37].includes(this.event.type)
    },
    change(){
      return [12, 35].includes(this.event.type)
    },
    showDescription(){
      return !this.change
    }
  }
}
</script>

<style>
.event-minute {
  min-width: 2rem;
}

.event-extra-minute {
  font-size: xx-small;
  vertical-align: top;
}
</style>